import { em, math } from 'polished'
import styled, { css } from 'styled-components'

import { H2 } from 'styles/components/typography'
import { h4 } from 'styles/mixins_styled/typography'

const indentLeftK = 0.72
const topIndent = em(20)
const topIndentMd = math(`${topIndent} * 2`)

export const Wrapper = styled.div`
  padding-top: ${topIndent};
  color: ${p => p.textColor};

  ${p => p.theme.mq.upMd} {
    padding-top: ${topIndentMd};
    padding-left: 0;
  }
`

export const Square = styled.div`
  position: absolute;
  width: ${p => p.theme.blocks.squareSize};
  height: ${p => p.theme.blocks.squareSize};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background-color: ${p => p.bgColor};

  ${p => p.theme.mq.upMd} {
    width: ${p => p.theme.blocks.squareSizeMd};
    height: ${p => p.theme.blocks.squareSizeMd};
  }
`

export const Line = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${p => math(`${p.theme.blocks.squareSize} / 2`)};
  width: ${em(1)};
  transform: translateX(-50%);

  &.light {
    background: ${p => p.theme.colors.whiteOp15};
  }

  &.dark {
    background: ${p => p.theme.colors.blackOp07};
  }

  &.first {
    top: ${p => math(`${topIndent} + ${p.theme.blocks.squareSize} / 2`)};
  }

  &.last {
    bottom: auto;
    height: ${p => math(`${topIndent} + ${p.theme.blocks.squareSize} / 2`)};
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: ${p => math(`${topIndent} + ${p.theme.blocks.squareSize} / 2`)};
      width: ${em(10)};
      height: ${em(10)};
      background: ${p => p.theme.colors.blackOp07NonTransp};
      transform: translate(-50%, -50%);
    }
  }

  ${p => p.theme.mq.upMd} {
    left: ${p => math(`${p.theme.blocks.squareSizeMd} / 2`)};

    &.first {
      top: ${p => math(`${topIndentMd} + ${p.theme.blocks.squareSizeMd} / 2`)};
    }

    &.last {
      bottom: auto;
      height: ${p =>
        math(`${topIndentMd} + ${p.theme.blocks.squareSizeMd} / 2`)};

      &:before {
        top: ${p =>
          math(`${topIndentMd} + ${p.theme.blocks.squareSizeMd} / 2`)};
      }
    }
  }
`

export const Inner = styled.div`
  min-height: ${p =>
    math(`${p.theme.typography.h2} * ${p.theme.typography.h2Lh} * 2`)};
  position: relative;
  z-index: 1;

  ${p => p.theme.mq.upMd} {
    min-height: ${p =>
      math(`${p.theme.typography.h2} * ${p.theme.typography.h2Lh} * 3`)};
  }

  ${p => p.theme.mq.upLg} {
    display: flex;
  }
`

export const Title = styled(H2)`
  display: inline-block;
  max-width: 95%;
  ${h4};
  margin-top: 4px;

  ${p => p.theme.mq.upMd} {
    max-width: 67%;
    margin-top: 0;
  }

  ${p => p.theme.mq.upLg} {
    flex: auto;
    max-width: none;
  }
`

export const Content = styled.div`
  position: relative;
  padding-top: ${p =>
    math(
      `(${p.theme.blocks.squareSize} - (${p.theme.typography.h2} * ${p.theme.typography.h2Lh})) / 2`,
    )};
  padding-left: ${p => math(`${p.theme.blocks.squareSize} * ${indentLeftK}`)};

  ${p =>
    !p.isRu &&
    css`
      & a {
        word-break: break-all;
      }
    `}

  ${p => p.theme.mq.upMd} {
    padding-top: ${p =>
      math(
        `(${p.theme.blocks.squareSizeMd} - (${p.theme.typography.h2} * ${p.theme.typography.h2Lh})) / 2`,
      )};
    padding-left: ${p =>
      math(`${p.theme.blocks.squareSizeMd} * ${indentLeftK}`)};
  }
`

export const StepNumber = styled(H2)`
  ${h4};
  margin-bottom: 0;
`
